/**
 * Error that is raised when an HTTP request takes longer than the configured
 * timeout period. This error is usually transient and could indicate an
 * overloaded or faulting HTTP server, or a slow connection.
 */
export class HttpTimeoutError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
//# sourceMappingURL=http-timeout-error.js.map